// MAD TURBO — Services data (LT + EN)
// Each service has full copy for the dedicated service page.

export const services = [
  {
    slug: "stage-1-ecu-remap",
    category: "performance",
    title: { lt: "Stage 1 ECU kalibravimas", en: "Stage 1 ECU Remap" },
    short: {
      lt: "Optimalus galios prieaugis serijiniam automobiliui be aparatinių pakeitimų.",
      en: "Optimal power gain for a stock vehicle without hardware changes.",
    },
    intro: {
      lt: "Stage 1 kalibravimas – tai profesionalus originalios ECU programinės įrangos perrašymas serijiniam automobiliui. Kalibruojame įpurškimą, uždegimą, boost slėgį ir droselio atsaką pagal kiekvieno variklio individualias savybes.",
      en: "Stage 1 is a professional recalibration of the original ECU software for a stock vehicle. We adjust injection, ignition, boost pressure and throttle response according to the individual characteristics of each engine.",
    },
    benefits: {
      lt: [
        "Padidėjęs galingumas ir sukimo momentas",
        "Geresnis droselio atsakas",
        "Sklandesnis pagreitis",
        "Galimas kuro sąnaudų sumažėjimas",
        "Saugios kalibravimo ribos",
        "Grįžtamas į originalią programinę įrangą",
      ],
      en: [
        "Increased power and torque",
        "Improved throttle response",
        "Smoother acceleration",
        "Possible fuel economy improvement",
        "Safe calibration limits",
        "Reversible to original software",
      ],
    },
    suitable: {
      lt: "Serijiniai benzininiai ir dyzeliniai automobiliai su turbo arba atmosferiniais varikliais.",
      en: "Stock petrol and diesel vehicles with turbo or naturally aspirated engines.",
    },
    results: {
      lt: "Vidutinis galios prieaugis: 15–25% priklausomai nuo variklio ir gamintojo kalibravimo tolerancijos.",
      en: "Average power gain: 15–25% depending on engine and OEM calibration tolerance.",
    },
    related: ["stage-2-ecu-remap", "eco-tuning", "custom-ecu-calibration"],
  },
  {
    slug: "stage-2-ecu-remap",
    category: "performance",
    title: { lt: "Stage 2 ECU kalibravimas", en: "Stage 2 ECU Remap" },
    short: {
      lt: "Kalibravimas su papildomais hardware patobulinimais – downpipe, intake, intercooler.",
      en: "Calibration paired with hardware upgrades – downpipe, intake, intercooler.",
    },
    intro: {
      lt: "Stage 2 – tai kitas žingsnis po Stage 1. Kalibravimas apima hardware pokyčius, tokius kaip sportinis downpipe, hi-flow intercooler, sportinis oro filtras arba pilnas įpurškimo sistemos patobulinimas. Kiekvienas Stage 2 projektas kalibruojamas individualiai.",
      en: "Stage 2 is the next step after Stage 1. Calibration accounts for hardware changes such as a sports downpipe, hi-flow intercooler, performance intake or an upgraded injection system. Every Stage 2 project is calibrated individually.",
    },
    benefits: {
      lt: [
        "Reikšmingas galios ir sukimo momento prieaugis",
        "Optimizuota veikimo temperatūra",
        "Geresnis dinaminių apkrovų valdymas",
        "Pilnas hardware ir software suderinimas",
      ],
      en: [
        "Significant power and torque increase",
        "Optimised operating temperatures",
        "Better dynamic load management",
        "Full hardware and software integration",
      ],
    },
    suitable: {
      lt: "Automobiliai su instaliuotais performance komponentais.",
      en: "Vehicles with installed performance components.",
    },
    results: {
      lt: "Galios prieaugis: 25–40% nuo serijinės specifikacijos.",
      en: "Power gain: 25–40% from stock specification.",
    },
    related: ["stage-1-ecu-remap", "stage-3-ecu-remap", "custom-ecu-calibration"],
  },
  {
    slug: "stage-3-ecu-remap",
    category: "performance",
    title: { lt: "Stage 3 ECU kalibravimas", en: "Stage 3 ECU Remap" },
    short: {
      lt: "Kalibravimas automobiliams su rimtais hardware upgrade’ais – turbo, injektoriai, kuro sistema.",
      en: "Calibration for vehicles with major hardware upgrades – turbo, injectors, fuel system.",
    },
    intro: {
      lt: "Stage 3 projektai apima profesionalų ECU kalibravimą automobiliams su reikšmingai patobulintais aparatiniais komponentais. Kiekviena kalibracija kuriama individualiai pagal automobilio konfigūraciją.",
      en: "Stage 3 projects include professional ECU calibration for vehicles equipped with significantly upgraded hardware. Each calibration is developed individually according to vehicle configuration.",
    },
    benefits: {
      lt: [
        "Visiškas suderinimas su hardware konfigūracija",
        "Pilnas kuro ir uždegimo žemėlapių perrašymas",
        "Saugios ribos aukštai galiai",
        "Data log pagrindu kalibravimas",
      ],
      en: [
        "Full integration with the hardware configuration",
        "Complete rewrite of fuel and ignition maps",
        "Safe limits for high-power operation",
        "Data-log based calibration",
      ],
    },
    suitable: {
      lt: "Automobiliai su patobulintais turbo, injektoriais, intercooler, kuro sistema, išmetimu, oro paėmimu ar individualiu hardware.",
      en: "Vehicles with upgraded turbo, injectors, intercooler, fuel system, exhaust, intake or custom hardware combinations.",
    },
    results: {
      lt: "Individualus rezultatas priklausomai nuo hardware paketo. Dažnai 40–100%+ galios prieaugis.",
      en: "Individual result depending on hardware package. Often 40–100%+ power gain.",
    },
    related: ["custom-ecu-calibration", "stage-2-ecu-remap", "launch-control"],
  },
  {
    slug: "custom-ecu-calibration",
    category: "performance",
    title: { lt: "Individualus ECU kalibravimas", en: "Custom ECU Calibration" },
    short: {
      lt: "Kiekvienas automobilis unikalus. Kiekviena kalibracija kuriama individualiai.",
      en: "Every vehicle is unique. Every calibration is developed individually.",
    },
    intro: {
      lt: "Kiekvienas automobilis mums yra atskiras projektas. Individualus ECU kalibravimas kuriamas atsižvelgiant į vairavimo stilių, tikslus ir automobilio konfigūraciją.",
      en: "Every vehicle is treated as a separate project. Custom ECU calibration is developed considering driving style, goals and specific vehicle configuration.",
    },
    benefits: {
      lt: [
        "Vairavimo malonumas",
        "Patikimumas",
        "Optimizuotas galios paskirstymas",
        "Saugumas",
        "Efektyvumas",
        "Suderinta su kliento tikslais",
      ],
      en: [
        "Driveability",
        "Reliability",
        "Optimised power delivery",
        "Safety",
        "Efficiency",
        "Aligned with customer goals",
      ],
    },
    suitable: {
      lt: "Bet koks modernus benzininis ar dyzelinis automobilis.",
      en: "Any modern petrol or diesel vehicle.",
    },
    results: {
      lt: "Kalibravimas, atitinkantis kliento poreikius ir techninę specifikaciją.",
      en: "A calibration matching client needs and technical specification.",
    },
    related: ["stage-1-ecu-remap", "stage-3-ecu-remap", "eco-tuning"],
  },
  {
    slug: "eco-tuning",
    category: "economy",
    title: { lt: "Eco kalibravimas", en: "Eco Tuning" },
    short: {
      lt: "Ekonominis kalibravimas orientuotas į mažesnes kuro sąnaudas.",
      en: "Economy calibration focused on lower fuel consumption.",
    },
    intro: {
      lt: "Eco kalibravimas – tai kalibravimo strategija, kuria siekiama sumažinti kuro sąnaudas be kompromisų dėl patikimumo. Optimizuojame įpurškimą, uždegimą ir dažnai naudojamą darbo zoną.",
      en: "Eco tuning is a calibration strategy aimed at reducing fuel consumption without compromising reliability. We optimise injection, ignition and the most frequently used operating zones.",
    },
    benefits: {
      lt: [
        "Sumažintos kuro sąnaudos",
        "Geresnis sukimo momentas žemuose apsukų diapazonuose",
        "Stabilesnis darbas mieste",
        "Ilgesnė variklio darbinė resursas",
      ],
      en: [
        "Reduced fuel consumption",
        "Better torque at low RPM ranges",
        "More stable city driving",
        "Longer engine service life",
      ],
    },
    suitable: {
      lt: "Fleet automobiliai, komerciniai automobiliai, kasdieniai keleiviniai automobiliai.",
      en: "Fleet vehicles, commercial vehicles, daily passenger cars.",
    },
    results: {
      lt: "Vidutinis kuro sąnaudų sumažėjimas: 5–15%.",
      en: "Average fuel saving: 5–15%.",
    },
    related: ["custom-ecu-calibration", "stage-1-ecu-remap"],
  },
  {
    slug: "dpf-solutions",
    category: "emissions",
    title: { lt: "DPF sprendimai", en: "DPF Solutions" },
    short: {
      lt: "Techniniai DPF sistemos sprendimai dyzeliniams automobiliams.",
      en: "Technical DPF solutions for diesel vehicles.",
    },
    intro: {
      lt: "Sprendžiame DPF (dyzelio kietųjų dalelių filtro) problemas – nuo diagnostikos iki software sprendimų. Kiekvienas atvejis analizuojamas individualiai atsižvelgiant į teisinius reikalavimus regiono lygiu.",
      en: "We resolve DPF (diesel particulate filter) issues — from diagnostics to software solutions. Each case is analysed individually considering local legal requirements.",
    },
    benefits: {
      lt: [
        "Techninis DPF diagnostikos sprendimas",
        "Sumažintos remonto išlaidos",
        "Stabilus variklio darbas",
      ],
      en: [
        "Technical DPF diagnostic solution",
        "Reduced repair costs",
        "Stable engine operation",
      ],
    },
    suitable: {
      lt: "Dyzeliniai automobiliai su DPF sistemos gedimais (sprendžiama pagal vietinius reikalavimus).",
      en: "Diesel vehicles with DPF issues (subject to local requirements).",
    },
    results: {
      lt: "Kiekvienas atvejis analizuojamas techniškai. Sprendimai laikantis vietinės teisės.",
      en: "Each case is analysed technically. Solutions comply with local legislation.",
    },
    related: ["egr-solutions", "adblue-solutions", "ecu-diagnostics"],
  },
  {
    slug: "egr-solutions",
    category: "emissions",
    title: { lt: "EGR sprendimai", en: "EGR Solutions" },
    short: { lt: "EGR sistemos techniniai sprendimai ir diagnostika.", en: "EGR system technical solutions and diagnostics." },
    intro: {
      lt: "EGR (išmetamųjų dujų recirkuliacijos) sistema dažnai kelia problemų senesniems dyzeliniams automobiliams. Techniniai sprendimai kuriami atsižvelgiant į vietinius reikalavimus.",
      en: "The EGR (exhaust gas recirculation) system often causes issues on older diesel vehicles. Technical solutions are developed considering local requirements.",
    },
    benefits: {
      lt: ["Techninė EGR diagnostika", "Sumažintas įsiurbimo kolektoriaus kaupimasis", "Stabilesnis variklio darbas"],
      en: ["Technical EGR diagnostics", "Reduced intake manifold buildup", "More stable engine operation"],
    },
    suitable: { lt: "Dyzeliniai automobiliai su EGR gedimais.", en: "Diesel vehicles with EGR faults." },
    results: { lt: "Techninis sprendimas pagal automobilio specifiką.", en: "Technical solution based on vehicle specifics." },
    related: ["dpf-solutions", "adblue-solutions", "ecu-diagnostics"],
  },
  {
    slug: "adblue-solutions",
    category: "emissions",
    title: { lt: "AdBlue sprendimai", en: "AdBlue Solutions" },
    short: { lt: "AdBlue sistemos diagnostika ir techniniai sprendimai.", en: "AdBlue system diagnostics and technical solutions." },
    intro: {
      lt: "AdBlue sistemos gedimai gali visiškai imobilizuoti automobilį. Atliekame profesionalią diagnostiką ir kuriame techninius sprendimus (laikantis vietinių taisyklių).",
      en: "AdBlue system faults can completely immobilise the vehicle. We provide professional diagnostics and develop technical solutions (subject to local regulations).",
    },
    benefits: { lt: ["Diagnostika ir techninis sprendimas", "Sumažinti remonto kaštai"], en: ["Diagnostics and technical solution", "Reduced repair costs"] },
    suitable: { lt: "Modernūs dyzeliniai komerciniai ir keleiviniai automobiliai.", en: "Modern diesel commercial and passenger vehicles." },
    results: { lt: "Individualus sprendimas priklausomai nuo automobilio.", en: "Individual solution depending on the vehicle." },
    related: ["dpf-solutions", "egr-solutions"],
  },
  {
    slug: "tcu-dsg-remap",
    category: "transmission",
    title: { lt: "TCU / DSG kalibravimas", en: "TCU / DSG Gearbox Remap" },
    short: { lt: "Automatinės ir DSG pavarų dėžės kalibravimas.", en: "Automatic and DSG gearbox calibration." },
    intro: {
      lt: "TCU (transmisijos valdymo bloko) kalibravimas – tai profesionalus DSG ir automatinių pavarų dėžių software optimizavimas. Rezultatas – greitesnis pavarų perjungimas, aukštesnis leidžiamas sukimo momentas, tikslesni pavarų taškai.",
      en: "TCU (transmission control unit) calibration is a professional software optimisation for DSG and automatic gearboxes. The result is faster shifts, higher torque handling and more precise shift points.",
    },
    benefits: {
      lt: ["Greitesni pavarų perjungimai", "Optimalus launch control", "Aukštesnis leidžiamas sukimo momentas", "Sklandesnis darbas"],
      en: ["Faster gear shifts", "Optimised launch control", "Higher torque capability", "Smoother operation"],
    },
    suitable: { lt: "DSG (DQ200, DQ250, DQ381, DL501) ir modernios automatinės pavarų dėžės.", en: "DSG (DQ200, DQ250, DQ381, DL501) and modern automatic gearboxes." },
    results: { lt: "Iki 30% greitesnis pavarų perjungimas, geresnis pagreitis.", en: "Up to 30% faster shifts, improved acceleration." },
    related: ["launch-control", "stage-2-ecu-remap"],
  },
  {
    slug: "launch-control",
    category: "performance",
    title: { lt: "Launch Control", en: "Launch Control" },
    short: { lt: "Profesionalus start’o valdymas maksimaliam pagreičiui.", en: "Professional launch control for maximum acceleration." },
    intro: {
      lt: "Aktyvuojame arba kalibruojame Launch Control funkciją – profesionalus start’o valdymas su optimizuotu RPM ir sankabos valdymu.",
      en: "We activate or calibrate Launch Control — professional launch management with optimised RPM and clutch control.",
    },
    benefits: { lt: ["Stabilus start’as", "Optimizuotas ratų sukibimas", "Nuoseklus rezultatas"], en: ["Stable launch", "Optimised traction", "Consistent result"] },
    suitable: { lt: "Automobiliai su DSG arba palaikoma platforma.", en: "Vehicles with DSG or supported platform." },
    results: { lt: "Sistemingas start’o valdymas be papildomo streso variklio komponentams.", en: "Systematic launch management without extra stress on engine components." },
    related: ["tcu-dsg-remap", "stage-2-ecu-remap"],
  },
  {
    slug: "hard-cut-limiter",
    category: "performance",
    title: { lt: "Hard Cut Limiter", en: "Hard Cut Limiter" },
    short: { lt: "Kietas apsukų ribotuvas motorsport tikslams.", en: "Hard-cut rev limiter for motorsport applications." },
    intro: {
      lt: "Hard cut limiter suteikia aiškų, momentinį apsukų nutraukimą. Naudojama motorsport aplikacijose ir aktyviame vairavime.",
      en: "A hard-cut limiter provides a clear, instant rev cut. Used in motorsport applications and active driving.",
    },
    benefits: { lt: ["Aiškus RPM ribotuvas", "Motorsport charakteristika"], en: ["Sharp RPM limit", "Motorsport character"] },
    suitable: { lt: "Track ir motorsport orientuoti automobiliai.", en: "Track and motorsport oriented vehicles." },
    results: { lt: "Aiškiai apibrėžta RPM riba.", en: "Clearly defined RPM limit." },
    related: ["rev-limiter-adjustment", "launch-control"],
  },
  {
    slug: "pop-and-bang",
    category: "performance",
    title: { lt: "Pop & Bang kalibravimas", en: "Pop & Bang Calibration" },
    short: { lt: "Charakteringas išmetimo garsas atleidžiant droselį.", en: "Characteristic exhaust sound on throttle lift." },
    intro: {
      lt: "Pop & Bang kalibravimas – profesionaliai suprogramuotas charakteringas išmetimo garsas atleidžiant droselį. Kalibruojama saugiai, be žalos katalizatoriui ir turbo.",
      en: "Pop & Bang is a professionally programmed characteristic exhaust sound on throttle lift. Calibrated safely, without harm to catalytic converter or turbo.",
    },
    benefits: { lt: ["Charakteringas garsas", "Kalibruotos saugios ribos"], en: ["Characteristic sound", "Calibrated safe limits"] },
    suitable: { lt: "Sporto tikslų arba track automobiliai.", en: "Sport or track purpose vehicles." },
    results: { lt: "Nuoseklus garsas be papildomos rizikos.", en: "Consistent sound without added risk." },
    related: ["launch-control", "hard-cut-limiter"],
  },
  {
    slug: "vmax-removal",
    category: "performance",
    title: { lt: "VMAX ribotuvo pašalinimas", en: "VMAX Removal" },
    short: { lt: "Gamintojo greičio ribotuvo pašalinimas.", en: "Removal of manufacturer speed limiter." },
    intro: {
      lt: "Pašaliname gamintojo greičio ribotuvą (dažniausiai 250 km/h). Rekomenduojama tik track naudojimui.",
      en: "We remove the manufacturer speed limiter (typically 250 km/h). Recommended for track use only.",
    },
    benefits: { lt: ["Pilnas automobilio potencialas", "Track naudojimo galimybės"], en: ["Full vehicle potential", "Track usage capability"] },
    suitable: { lt: "Automobiliai naudojami track’o sąlygomis.", en: "Vehicles used in track conditions." },
    results: { lt: "Ribotuvo pašalinimas iki mechaninių automobilio galimybių ribos.", en: "Limiter removed up to the mechanical limits of the vehicle." },
    related: ["rev-limiter-adjustment", "hard-cut-limiter"],
  },
  {
    slug: "rev-limiter-adjustment",
    category: "performance",
    title: { lt: "Apsukų ribotuvo koregavimas", en: "Rev Limiter Adjustment" },
    short: { lt: "RPM ribos koregavimas pagal hardware konfigūraciją.", en: "RPM limit adjustment for hardware configuration." },
    intro: {
      lt: "RPM ribotuvą koreguojame atsižvelgdami į variklio konfigūraciją ir mechanines ribas. Saugi kalibravimo praktika.",
      en: "We adjust the RPM limiter considering engine configuration and mechanical limits. Safe calibration practice.",
    },
    benefits: { lt: ["Suderinta RPM riba", "Saugios ribos"], en: ["Matched RPM limit", "Safe limits"] },
    suitable: { lt: "Automobiliai su hardware upgrade’ais.", en: "Vehicles with hardware upgrades." },
    results: { lt: "RPM riba, atitinkanti realų automobilio potencialą.", en: "RPM limit matching the vehicle's real potential." },
    related: ["stage-2-ecu-remap", "custom-ecu-calibration"],
  },
  {
    slug: "throttle-response",
    category: "performance",
    title: { lt: "Droselio atsako optimizavimas", en: "Throttle Response Optimization" },
    short: { lt: "Aštresnis, tiesesnis droselio atsakas.", en: "Sharper, more direct throttle response." },
    intro: {
      lt: "Optimizuojame droselio žemėlapius, kad automobilio reakcija į pedalą taptų aiškesnė ir tiesesnė.",
      en: "We optimise throttle maps so the vehicle's pedal response becomes sharper and more direct.",
    },
    benefits: { lt: ["Aiškesnis droselio atsakas", "Geresnis vairavimo pojūtis"], en: ["Sharper throttle response", "Improved driving feel"] },
    suitable: { lt: "Modernūs benzininiai ir dyzeliniai automobiliai.", en: "Modern petrol and diesel vehicles." },
    results: { lt: "Momentinis atsakas be aparatinių pakeitimų.", en: "Instant response without hardware changes." },
    related: ["stage-1-ecu-remap", "custom-ecu-calibration"],
  },
  {
    slug: "ecu-diagnostics",
    category: "programming",
    title: { lt: "ECU diagnostika", en: "ECU Diagnostics" },
    short: { lt: "Pilna profesionali ECU diagnostika.", en: "Full professional ECU diagnostics." },
    intro: {
      lt: "Atliekame išsamią ECU diagnostiką, klaidos kodų analizę, live data logus ir techninių problemų analizę.",
      en: "We perform full ECU diagnostics, DTC analysis, live data logs and technical issue investigation.",
    },
    benefits: { lt: ["Techninė analizė", "DTC skaitymas ir trynimas", "Live data logai"], en: ["Technical analysis", "DTC read and clear", "Live data logs"] },
    suitable: { lt: "Visi modernūs automobiliai.", en: "All modern vehicles." },
    results: { lt: "Techninė ataskaita su konkrečiu diagnostikos rezultatu.", en: "Technical report with concrete diagnostic result." },
    related: ["ecu-recovery", "ecu-cloning", "checksum-correction"],
  },
  {
    slug: "ecu-cloning",
    category: "programming",
    title: { lt: "ECU klonavimas", en: "ECU Cloning" },
    short: { lt: "Duomenų perkėlimas iš vieno ECU į kitą.", en: "Transfer of data from one ECU to another." },
    intro: {
      lt: "Perkeliame originalią programinę įrangą, kalibracijas ir immo duomenis į naują ECU. Naudinga sugadinto ECU pakeitimo atvejais.",
      en: "We transfer original software, calibrations and immo data to a new ECU. Useful for replacing a damaged ECU.",
    },
    benefits: { lt: ["Sutaupytos remonto išlaidos", "Originalaus ECU duomenų išsaugojimas"], en: ["Saved repair costs", "Original ECU data preserved"] },
    suitable: { lt: "Automobiliai su pakeistu arba sugadintu ECU.", en: "Vehicles with replaced or damaged ECU." },
    results: { lt: "Nauja arba pakeista ECU su tais pačiais duomenimis.", en: "New or replaced ECU with the same data." },
    related: ["ecu-recovery", "original-software-restoration"],
  },
  {
    slug: "ecu-recovery",
    category: "programming",
    title: { lt: "ECU atkūrimas", en: "ECU Recovery" },
    short: { lt: "Sugedusio ECU atkūrimas.", en: "Recovery of a damaged ECU." },
    intro: {
      lt: "Atkuriame sugedusius ECU – dažnai per Bench arba Boot metodus. Techninis atkūrimas kruopščiai kruopščiam techniniam darbui.",
      en: "We recover damaged ECUs — often through Bench or Boot methods. Technical recovery for demanding repair work.",
    },
    benefits: { lt: ["Sugadinto ECU sugrąžinimas į darbinę būklę", "Sutaupytas naujo ECU pirkimas"], en: ["Return of damaged ECU to working condition", "Saving cost of a new ECU"] },
    suitable: { lt: "Sugedę ECU po nepavykusio programavimo, elektrinių gedimų ar kitų priežasčių.", en: "ECUs damaged after failed programming, electrical failures or other causes." },
    results: { lt: "Grąžintas darbo režimas su originalia programine įranga.", en: "Restored operation with original software." },
    related: ["ecu-cloning", "original-software-restoration", "boot-programming"],
  },
  {
    slug: "original-software-restoration",
    category: "programming",
    title: { lt: "Originalios programinės įrangos atkūrimas", en: "Original Software Restoration" },
    short: { lt: "Grąžinimas į gamyklinę ECU būseną.", en: "Return to factory ECU state." },
    intro: {
      lt: "Grąžiname automobilio ECU į originalią gamyklinę programinę įrangą. Naudinga prieš servisą, prieš garantinį remontą arba automobilio pardavimą.",
      en: "We return the vehicle ECU to original factory software. Useful before service, warranty work, or selling the vehicle.",
    },
    benefits: { lt: ["Gamyklinė būklė", "Švarus OBD nuskaitymas"], en: ["Factory state", "Clean OBD read"] },
    suitable: { lt: "Bet koks anksčiau kalibruotas automobilis.", en: "Any previously calibrated vehicle." },
    results: { lt: "Automobilio ECU atitinka gamyklinę specifikaciją.", en: "Vehicle ECU matches factory specification." },
    related: ["ecu-recovery", "ecu-cloning"],
  },
  {
    slug: "obd-programming",
    category: "programming",
    title: { lt: "OBD programavimas", en: "OBD Programming" },
    short: { lt: "ECU programavimas per diagnostikos jungtį.", en: "ECU programming through diagnostic port." },
    intro: {
      lt: "OBD programavimas – standartinis būdas perrašyti ECU per diagnostikos jungtį. Tinka daugumai modernių platformų.",
      en: "OBD programming — the standard method to rewrite an ECU through the diagnostic port. Suitable for most modern platforms.",
    },
    benefits: { lt: ["Greitas procesas", "Nereikia išmontuoti ECU"], en: ["Fast process", "No need to remove the ECU"] },
    suitable: { lt: "Dauguma modernių automobilių.", en: "Most modern vehicles." },
    results: { lt: "Sėkmingas ECU perrašymas su išsaugota atsargine kopija.", en: "Successful ECU rewrite with backup preserved." },
    related: ["bench-programming", "boot-programming", "checksum-correction"],
  },
  {
    slug: "bench-programming",
    category: "programming",
    title: { lt: "Bench programavimas", en: "Bench Programming" },
    short: { lt: "Programavimas tiesiogiai ant ECU darbastalio.", en: "Programming directly on the ECU bench." },
    intro: {
      lt: "Bench programavimas leidžia atlikti pilną read/write operaciją ant ECU stalo – naudinga platformoms, kurių OBD prieiga apribota.",
      en: "Bench programming allows a full read/write operation on the ECU bench — useful for platforms where OBD access is limited.",
    },
    benefits: { lt: ["Pilna prieiga prie ECU", "Sudėtingų platformų palaikymas"], en: ["Full access to the ECU", "Support for complex platforms"] },
    suitable: { lt: "Modernūs ECU su ribota OBD prieiga.", en: "Modern ECUs with limited OBD access." },
    results: { lt: "Sėkminga read/write operacija saugiu būdu.", en: "Successful read/write operation via safe method." },
    related: ["obd-programming", "boot-programming"],
  },
  {
    slug: "boot-programming",
    category: "programming",
    title: { lt: "Boot programavimas", en: "Boot Programming" },
    short: { lt: "Boot lygio ECU programavimas sudėtingoms platformoms.", en: "Boot level ECU programming for complex platforms." },
    intro: {
      lt: "Boot programavimas naudojamas sudėtingoms platformoms, kai reikalinga tiesioginė prieiga per boot pinus.",
      en: "Boot programming is used on complex platforms where direct access via boot pins is required.",
    },
    benefits: { lt: ["Prieiga prie apsaugotų ECU", "Sudėtingų procesorių palaikymas"], en: ["Access to protected ECUs", "Support for complex processors"] },
    suitable: { lt: "Specifiniai ECU projektai.", en: "Specific ECU projects." },
    results: { lt: "Sėkminga operacija, kai kiti metodai negalimi.", en: "Successful operation when other methods are not available." },
    related: ["bench-programming", "ecu-recovery"],
  },
  {
    slug: "checksum-correction",
    category: "programming",
    title: { lt: "Checksum korekcija", en: "Checksum Correction" },
    short: { lt: "Kontrolinės sumos korekcija po programinės įrangos keitimo.", en: "Checksum correction after software modification." },
    intro: {
      lt: "Po ECU software modifikavimo būtina atkurti kontrolines sumas. Tai užtikrina, kad ECU tinkamai priims naują failą.",
      en: "After ECU software modification the checksums must be restored. This ensures the ECU accepts the new file properly.",
    },
    benefits: { lt: ["Sėkmingas programavimas", "Techninis tikslumas"], en: ["Successful programming", "Technical accuracy"] },
    suitable: { lt: "Bet koks ECU failas po modifikavimo.", en: "Any ECU file after modification." },
    results: { lt: "Failas priimtinas ECU be klaidų.", en: "File accepted by the ECU without errors." },
    related: ["obd-programming", "bench-programming"],
  },
];

export const serviceCategories = [
  { key: "performance", labelKey: "services.categoryPerformance" },
  { key: "economy", labelKey: "services.categoryEconomy" },
  { key: "emissions", labelKey: "services.categoryEmissions" },
  { key: "transmission", labelKey: "services.categoryTransmission" },
  { key: "programming", labelKey: "services.categoryProgramming" },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
